import loanFormModel from '../../form_models/loanFormModel';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { MortgageStatementRuleset } from '../../business/ruleset';
import { RulesetResult } from '../../business/rules';

const {
  companyDocuments: { pgMortgageStatement },
} = loanFormModel.formField;

export class PgMortgageStatementValidation implements ValidationSchema {
  public name = pgMortgageStatement.name;
  public label = '';
  public type = 'mixed';
  public required = {
    message: '',
    value: false,
  };
  public ruleset = MortgageStatementRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    schema = FileNameValidationSchema(pgMortgageStatement.name, required);
    if (required) schema = schema.required('This document is required');

    return schema;
  }
}
export default new Validation(new PgMortgageStatementValidation());
